// Yield long enough for the browser to actually paint before we hand it a
// multi-second synchronous render. Without this, the "computing" state and the
// render happen in the same tick, React never commits the loading state, and the
// user stares at the previous frame with no indication anything is happening.
// rAF gets us to the next frame; the nested timeout lets that frame composite.
//
// Extracted from useRenderedEntry when /explore gained an auto-start render: both
// callers are pushing renderRegion off the paint path for the same reason, and a
// second copy of this would be a second thing to get subtly wrong.
const yieldToPaint = () => new Promise(resolve => {
    if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => window.setTimeout(resolve, 0));
    } else {
        window.setTimeout(resolve, 0);
    }
});

export default yieldToPaint;
